import React from "react";
import "./Brands.css";

const brands = [
  // Agrupamos los logos en arrays de filas
  [
    "images/logos/Decathlon.svg",
    "images/logos/Nissan.svg",
    "images/logos/Old Navy.svg"
  ],
  [
    "images/logos/AE.svg",
    "images/logos/Ferragamo.svg",
    "images/logos/Lacoste.svg",
    "images/logos/Ferrero Rocher.svg"
  ],
  [
    "images/logos/Akron.svg",
    "images/logos/Ikea.svg",
    "images/logos/Inditex.svg"
  ],
  [
    "images/logos/CK.svg",
    "images/logos/Continental.svg",
    "images/logos/Hugo Boss.svg",
    "images/logos/Collins.svg"
  ],
  [
    "images/logos/H&M.svg",
    "images/logos/Vidanta.svg",
    "images/logos/Cuidado con el perro.svg"
  ],
  [
    "images/logos/Liverpool.svg",
    "images/logos/Carters.svg",
    "images/logos/GAP.svg",
    "images/logos/Chanel.svg"
  ],
  [
    "images/logos/Hollister.svg",
    "images/logos/The Home Depot.svg",
    "images/logos/Guess.svg"
  ],
  [
    "images/logos/Pandora.svg",
    "images/logos/Sears.svg",
    "images/logos/Pisa.svg",
    "images/logos/Ulta Beauty.svg"
  ],
  [
    "images/logos/Tommy Hilfiger.svg",
    "images/logos/Victorias Secret.svg",
    "images/logos/Victorinox.svg"
  ],
  [
    "images/logos/HH Global.svg",
    "images/logos/Volaris.svg",
    "images/logos/Loccitane.svg",
    "images/logos/Krispy Kreme.svg"
  ]
];

function Brands() {
  return (
    <section className="brands-section">
        <img src="../images/logo/Moti Logo.svg"></img>
      <h2 className="brands-title">Marcas que confían en nosotros</h2>
      <p className="brands-subtitle">ELLOS YA VIVEN LA EXPERIENCIA MOTI</p>
      <div className="brands-container">
        {brands.map((row, rowIndex) => (
          <div className="brands-row" key={rowIndex}>
            {row.map((logo, index) => (
              <img
                key={index}
                src={logo}
                alt={`brand-${index}`}
                className="brand-logo"
              />
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Brands;
